import { CreateButton, List, useTable } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { Button, Space, Table, Tag, Typography } from "antd";

import { TvCollection, tvErrorNotification, tvLeagueTitle } from "../Lib";
import { TvDelete } from "../Components";

export const TvCollectionsPage = () => {
  const { push } = useNavigation();
  const { tableProps, tableQueryResult } = useTable<TvCollection>({
    resource: "tv-collections",
    dataProviderName: "tvDataProvider",
    syncWithLocation: false,
    pagination: { mode: "off" },
    ...tvErrorNotification("Не удалось загрузить"),
  });

  return (
    <List
      title="ФНЛ ТВ — подборки"
      resource="tv-collections"
      breadcrumb={false}
      canCreate={false}
      headerButtons={
        <CreateButton resource="tv-collections">Добавить подборку</CreateButton>
      }
    >
      <Typography.Paragraph type="secondary">
        Редакторские категории главной: «Лучшие матчи сезона», «Камбэки»,
        «Исторические игры»… Порядок на главной — по полю «Порядок», состав и
        порядок видео задаются внутри подборки.
      </Typography.Paragraph>
      <Table {...tableProps} rowKey="id" pagination={false}>
        <Table.Column<TvCollection>
          title="Подборка"
          render={(_, c) => (
            <Space direction="vertical" size={2}>
              <Typography.Text strong>{c.title}</Typography.Text>
              <Typography.Text type="secondary">/{c.slug}</Typography.Text>
            </Space>
          )}
        />
        <Table.Column<TvCollection>
          title="Лига"
          width={220}
          render={(_, c) =>
            c.leagueId ? tvLeagueTitle(c.leagueId) : "Все лиги"
          }
        />
        <Table.Column<TvCollection>
          title="Видео"
          width={90}
          render={(_, c) => c.videoIds.length}
        />
        <Table.Column<TvCollection>
          title="Порядок"
          dataIndex="sortOrder"
          width={100}
        />
        <Table.Column<TvCollection>
          title=""
          width={120}
          render={(_, c) =>
            c.isActive ? null : <Tag color="orange">Выключена</Tag>
          }
        />
        <Table.Column<TvCollection>
          title="Действия"
          width={200}
          render={(_, c) => (
            <Space direction="vertical" style={{ width: "100%" }}>
              <Button
                size="small"
                block
                onClick={() => push(`/tv/collections/${c.id}`)}
              >
                Открыть
              </Button>
              <TvDelete
                resource="tv-collections"
                id={c.id}
                name={c.title}
                entityAccusative="подборку"
                onDeleted={() => tableQueryResult.refetch()}
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
